import React from 'react';
import { STATUTS } from '../data/constants';

export default function StatusBadge({ statut }) {
  const s = STATUTS[statut] || STATUTS.depot;
  return (
    <span style={{
      background:  s.bg,
      color:       s.color,
      padding:     '4px 12px',
      borderRadius: 20,
      fontSize:    12,
      fontWeight:  700,
      display:     'inline-flex',
      alignItems:  'center',
      gap:         6,
      whiteSpace:  'nowrap',
    }}>
      <span style={{
        width: 7, height: 7,
        borderRadius: '50%',
        background: s.dot,
        display: 'inline-block',
        flexShrink: 0,
      }} />
      {s.icon} {s.label}
    </span>
  );
}
